// @ts-nocheck
import humanizeString from 'humanize-string'
import findIndex from 'lodash/findIndex'
import isBoolean from 'lodash/isBoolean'
import isEmpty from 'lodash/isEmpty'
import isNumber from 'lodash/isNumber'
import omit from 'lodash/omit'

import {
  CustomFieldKind,
  CustomFieldSectionProjection,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { removeMoneyMask } from '@avantstay/backoffice-core'

import { CustomFieldProps } from '@new/__global/components/CustomField/_types'
// eslint-disable-next-line import/no-cycle
import customFieldsDefinitions from '@new/__global/components/CustomField/types'
import { ownerStatusCustomFieldId } from '@new/domains/properties/screens/propertyInfo/_utils'
import { omitCustomFieldsSectionsIds } from '@new/domains/properties/screens/propertyInfo/contants'
import { maskByFieldType } from '@new/domains/settings/screens/customFieldsConfig/CustomFieldsConfig.definitions'

import { CustomFieldProjection } from '@arriere/types/CustomFields.types'
import { CustomFieldsNormalizedProps } from '@new/domains/properties/_types'

export const ALLOW_PAYMENT_PLAN_ON_WEBSITE_CUSTOM_FIELD_ID =
  'c009ca01-cb18-40c0-8f38-0c0ae6ef3914'
export const BOOKING_ALTERATION_MODE_CUSTOM_FIELD_ID = 'dcffd7c8-69ae-11f0-b28f-19f2bccf6551'
export const BOOKING_ALTERATION_MODE_ROOM_TYPE = 'ROOM_TYPE'
export const HOTEL_LEVEL_UNIT_ASSIGNMENT_TIMING_RULE_CUSTOM_FIELD_ID =
  '15970662-69ad-11f0-b28f-19f2bccf6551'
export const HOTEL_LEVEL_BOOKING_ALTERATION_MODE_CUSTOM_FIELD_ID =
  '6e5bee66-69ad-11f0-b28f-19f2bccf6551'
export const BOOKING_LEAD_TIME_HOURS_CUSTOM_FIELD_ID = '9379d8cc-b69e-11f1-bc3a-cd0bf940f708'
export const BUYOUT_RATE_MODIFIER_CUSTOM_FIELD_ID = '304c442e-ca06-475e-a891-b733e5da11d0'
export const COMMS_CATEGORIES_OPTOUT_CUSTOM_FIELD_ID = 'bdd7ec24-09da-11ec-a264-00155d29a35a'
export const DELIGHTED_PROJECT_ID_CUSTOM_FIELD_ID = '1dd621f9-de60-413d-ae4b-1e85c050fec5'
export const DISTRIBUTION_AGENCIES_OPTOUT_CUSTOM_FIELD_ID =
  '3dbfa104-a0a3-481b-ac68-c3cbae28a958'
export const ENABLE_NPS_SURVEY_CUSTOM_FIELD_ID = '40120b71-f946-4f64-b547-e62fa57b59bb'
export const HAS_PARKING_CUSTOM_FIELD_ID = '1fd9dfcb-8fbc-45bb-bb9c-023ed92c1238'
export const LEASE_PET_COUNT_ALLOWED_CUSTOM_FIELD_ID = 'a12dbecc-26f7-11ea-a680-503eaadea111'
export const LTR_MINIMUM_NIGHT_FLOOR_CUSTOM_FIELD_ID = 'c8c0b940-a607-4f3c-b7d0-2139eddf9994'
export const MAX_NUMBER_OF_CARS_CUSTOM_FIELD_ID = 'a6f3cc6e-2258-11ea-978f-2e728ce88125'
export const MINIMUM_BOOKING_VALUE_FOR_PAYMENT_PLAN_CUSTOM_FIELD_ID =
  '0c6ed293-6d50-4149-a294-d79e1db775f2'
export const ONBOARDING_ACCESS_INFORMATION_NOTES_CUSTOM_FIELD_ID =
  '5a2121a0-eca8-4da1-89b8-fffe6a08eecc'
export const ONBOARDING_ALLOWED_FIRST_ACCESS_DATE_CUSTOM_FIELD_ID =
  '539ef856-0c2c-4144-bae5-2101ab0d3718'
export const ONBOARDING_BACK_DOOR_CUSTOM_FIELD_ID = '016618ca-6cec-4137-9bee-6b67bc464c8c'
export const ONBOARDING_FRONT_DOOR_CUSTOM_FIELD_ID = '51885f29-f9d3-4b0b-ae8f-4bdad6bc34a2'
export const ONBOARDING_GARAGE_CUSTOM_FIELD_ID = '81803863-f358-4419-b500-2e6f98cda999'
export const ONBOARDING_GENERAL_PROPERTY_INFORMATION_CUSTOM_FIELD_ID =
  '9287548b-5fab-4d73-b9cb-aa851f5654d2'
export const ONBOARDING_OTHER_ACCESS_CODES_CUSTOM_FIELD_ID = '5ac81b44-3170-4d42-b717-b8f333c2ca22'
export const ONBOARDING_WIFI_NAME_CUSTOM_FIELD_ID = '4878a1bc-1bbf-4fb1-962f-4b6e14bf04cb'
export const ONBOARDING_WIFI_PASSWORD_CUSTOM_FIELD_ID = '1ba6a027-9b22-4437-99e4-4bc5f23521b6'
export const OVERRIDE_MINIMUM_NIGHTS_TO_LTR_CUSTOM_FIELD_ID = '38f4e5a8-8230-489f-bf3b-6f9f18f04215'
export const PARKING_DETAILS_CUSTOM_FIELD_ID = 'a6f3cdd6-2258-11ea-978f-2e728ce88125'
export const PARKING_LOCATION_CUSTOM_FIELD_ID = '9515b205-ff62-4bc4-83b8-3aa75089e80f'
export const PET_POLICY_CUSTOM_FIELD_ID = 'b4cb8ec8-241e-11eb-b8aa-93b9b718e7ca'
export const PET_POLICY_RESTRICTIONS_CUSTOM_FIELD_ID = '9bd7971e-f5e4-11ee-98f1-990bfb5a25df'
export const PROPERTY_TYPE_CUSTOM_FIELD_ID = 'd593ebbc-159b-41e9-9e81-c1922fe33aa3'
export const SECURITY_DEPOSIT_CUSTOM_FIELD_ID = 'f482b75c-26f8-11ea-a680-503eaadea111'
export const SHOW_EXACT_ADDRESS_ON_AGENCIES_CUSTOM_FIELD_ID =
  'dea64246-d96d-4916-a233-97059632a3ff'
export const SQUARE_FOOTAGE_CUSTOM_FIELD_ID = '7e7b70db-6e9a-11eb-b511-295ac0a8b868'
export const REQUIRE_CLEANING_FEE_CUSTOM_FIELD_ID = 'a79fe58e-a48d-4631-8ded-2fbc1462bc53'
export const REVENUE_MANAGEMENT_TAGS_CUSTOM_FIELD_ID = '0421751a-50ec-11ef-926b-c19a209da016'
export const RM_ANNUAL_REVENUE_FORECAST_BEAR = '27f8d914-08fc-11f0-9a01-dbeb1882045d'
export const RM_ANNUAL_REVENUE_FORECAST_BASE = '6a5b819e-08fc-11f0-9a01-dbeb1882045d'
export const RM_ANNUAL_REVENUE_FORECAST_BULL = '6dc1c1d6-08fc-11f0-9a01-dbeb1882045d'
export const WORK_ORDER_TEMPLATE_TYPE_CUSTOM_FIELD_ID = 'c0a8bb39-da42-4a4e-be0d-bda9471c6507'

export const DIRECT_AND_OTHER_SETTINGS_SECTION_ID = 'a268c2bc-1c4a-11ea-b8f4-d787ffaf67ea'
export const ENTRY_INFORMATION_SECTION_ID = '1f2c1aa4-5b3c-4d77-9d3e-7b6f4a14a9a1'
export const LIFECYCLE_SECTION_ID = '3878fb22-91d1-4249-a118-4eab3851e60c'
export const REVENUE_CONFIGURATION_SECTION_ID = '6844f51f-e09e-4713-8b93-211618c38036'
export const LEASE_AND_FINANCE_SECTION_ID = 'ef596218-26f7-11ea-a680-503eaadea111'
export const ONBOARDING_SECTION_ID = 'a551ab71-59ce-11eb-b90c-7b534cdc3ab4'

interface CustomFieldsConfigProps {
  id: string
  fields?: CustomFieldProjection[]
}

export const findCustomFieldById = ({ id, fields }: CustomFieldsConfigProps) => {
  const index = findIndex(fields, { id })

  return {
    customFieldData: fields?.[index],
    index,
  }
}

export const optionsByCustomFieldKind = {
  [CustomFieldKind.boolean]: [
    {
      value: true,
      label: 'Yes',
    },
    {
      value: false,
      label: 'No',
    },
  ],
}

export const hasOptions = [CustomFieldKind.optionsMultiple, CustomFieldKind.optionsSingle]

export function parseValuesToOptions(
  id: string,
  kind: CustomFieldKind,
  defaultValue: any,
  values?: Array<any>,
) {
  const isMultipleOptions = kind === CustomFieldKind.optionsMultiple

  return values
    ? values.map(v => {
        const value = JSON.parse(v)

        const defaultChecked =
          isMultipleOptions && defaultValue ? defaultValue.includes(value) : false

        return {
          title: humanizeString(value),
          value,
          default: defaultChecked,
          id: `${id}(${value})`,
        }
      })
    : []
}

interface GetCustomFieldProps<CustomFieldType> {
  customFields: CustomFieldType[]
  id: string
}

export const getCustomFields = <CustomFieldType extends {}>({
  customFields,
  id,
}: GetCustomFieldProps<CustomFieldType>) => {
  const groupedFields = customFields.reduce(
    (prev: CustomFieldProjection[], customField) => [...prev, ...customField.fields],
    [],
  )

  return groupedFields?.find(field => {
    return field.id === id
  })
}

interface IGetCustomField {
  customFields: CustomFieldSectionProjection[]
  id: string
  type: 'fields' | 'section'
}

export function getCustomField<T>({ customFields, id, type }: IGetCustomField): T | undefined {
  let field

  if (type === 'section') {
    field = customFields.find(it => it.section.id === id)
  } else {
    field = customFields
      .reduce((prev: any, it) => [...prev, ...it.fields], [])
      .find((it: CustomFieldProps) => it.id === id)
  }

  return field
}

export const notReadOnlySection = <CustomFieldSection extends { section: { readOnly?: boolean } }>(
  it: CustomFieldSection,
) => !it.section.readOnly

export function withFields<CustomFieldSection extends {}>(it: CustomFieldSection) {
  return !isEmpty(it.fields)
}

export const jsonParseCustomFieldValue = (customField: Pick<CustomFieldProps, 'value'>) => {
  try {
    return customField.value !== null || customField.value !== undefined
      ? JSON.parse(customField.value)
      : ''
  } catch (error) {
    return customField.value
  }
}

export function parseSectionFields<CustomFieldProjectionType extends {}>(
  it: CustomFieldProjectionType,
): CustomFieldProjectionType {
  return {
    ...it,
    fields: it.fields.map(field => {
      const fieldOptions = hasOptions.includes(field.kind)
        ? parseValuesToOptions(
            field.id,
            field.kind,
            JSON.parse(field.value as string),
            field.options,
          )
        : []

      return {
        ...field,
        title: field.name,
        mask: maskByFieldType[field.kind],
        value: field.value === null ? '' : field.value,
        restriction: field.restriction,
        options: optionsByCustomFieldKind[field.kind]
          ? optionsByCustomFieldKind[field.kind]
          : fieldOptions,
      }
    }),
  }
}

export type ValuesObject = { [key: string]: CustomFieldProps }

const filterCustomFields = (fields: CustomFieldProps[], searchTerm: string) => {
  return fields.filter(field => {
    return field.name.toLowerCase().includes(searchTerm)
  })
}

export function filterCustomFieldsBySearchTerm<CustomFieldProjectionType extends {}>(
  customFields: CustomFieldProjectionType[],
  searchTerm?: string,
): CustomFieldProjectionType[] {
  if (!searchTerm) return customFields

  const searchTermLowerCase = searchTerm ? searchTerm.toLowerCase() : ''

  return customFields.reduce((prev: CustomFieldProjectionType[], next) => {
    const fieldsFiltered = filterCustomFields(next.fields, searchTermLowerCase)

    const sectionExist =
      next.section.name.toLowerCase().includes(searchTermLowerCase) ||
      omitCustomFieldsSectionsIds.includes(next.section.id)

    if (fieldsFiltered.length || sectionExist) {
      return [...prev, { ...next, fields: fieldsFiltered }]
    }

    return prev
  }, [])
}

export const filterCustomFieldsByIds = <CustomFieldProjectionType extends {}>(
  customFields: CustomFieldProjectionType[],
  fieldsToRemove?: string[],
): CustomFieldProjectionType[] => {
  if (!fieldsToRemove?.length) return customFields

  return customFields.reduce((prev: CustomFieldProjectionType[], next) => {
    const fieldsFiltered = next.fields.filter(field => {
      return !fieldsToRemove.includes(field.id)
    })

    const sectionExist = omitCustomFieldsSectionsIds.includes(next.section.id)

    if (fieldsFiltered.length || sectionExist) {
      return [...prev, { ...next, fields: fieldsFiltered }]
    }

    return prev
  }, [])
}

export const filterCustomFieldsBySectionIds = <CustomFieldProjectionType extends {}>(
  customFields: CustomFieldProjectionType[],
  sectionsToRemove?: string[],
): CustomFieldProjectionType[] => {
  if (!sectionsToRemove?.length) return customFields

  return customFields.filter(customField => !sectionsToRemove.includes(customField.section.id))
}

export const normalizeCustomFields = (prev: any, customField: CustomFieldSectionProjection) => {
  return {
    sections: [...prev.sections, customField.section],
    customFieldsbySectionId: {
      ...prev.customFieldsbySectionId,
      [customField.section.id]: customField.fields,
    },
  }
}

export function newNormalizeCustomFields<CustomFieldProjectionType>(
  customFields: CustomFieldProjectionType[],
): CustomFieldsNormalizedProps<CustomFieldProjectionType> {
  return customFields?.reduce(
    (prev, current) => {
      return {
        sections: [...prev.sections, (current as any).section],
        customFieldsbySectionId: {
          ...prev.customFieldsbySectionId,
          [(current as any).section.id]: (current as any).fields,
        } as typeof prev.customFieldsbySectionId,
      }
    },
    {
      sections: [],
      customFieldsbySectionId: {},
    } as CustomFieldsNormalizedProps<CustomFieldProjectionType>,
  )
}

export function newParseCustomFieldsToSave(
  formValues: { [key: string]: any },
  customFieldsProjection: CustomFieldProps[],
) {
  const parsedFormValues = omit(formValues, [ownerStatusCustomFieldId])
  const parsedCustomFields = customFieldsProjection?.filter(
    val => val.id !== ownerStatusCustomFieldId,
  )

  return Object.entries(parsedFormValues).map(([customFieldId, value]: any) => {
    const { customFieldData } = findCustomFieldById({
      fields: parsedCustomFields,
      id: customFieldId,
    })

    const typeDefinition = customFieldsDefinitions[customFieldData?.kind]

    let parsedValue
    if (typeDefinition && typeDefinition.parseValueToSave)
      parsedValue = typeDefinition.parseValueToSave({ ...customFieldData, value })
    else if ((value === '' || value === null) && customFieldData.restriction === 'OPTIONAL')
      parsedValue = 'null'
    else parsedValue = value

    return {
      customFieldId,
      value: parsedValue,
    }
  })
}

export const isFieldEmpty = (
  fieldValue: string | Array<string> | number | boolean | null | undefined,
) => {
  if (
    fieldValue === null ||
    fieldValue === undefined ||
    fieldValue === 'null' ||
    fieldValue === 'undefined'
  ) {
    return true
  }

  if (Array.isArray(fieldValue)) {
    return fieldValue.length === 0
  }

  if (isBoolean(fieldValue) || isNumber(fieldValue)) {
    return fieldValue === null
  }

  if (typeof fieldValue === 'string') {
    return !!fieldValue.match(/\[\n]/) || isEmpty(fieldValue.trim()) || fieldValue === '""'
  }

  return false
}

interface CustomFieldValueLookupField {
  id: string
  value?: string | null
}

interface CustomFieldValueLookupSection {
  fields: CustomFieldValueLookupField[]
}

export const getCustomFieldValue = (
  customFields: CustomFieldValueLookupSection[],
  customFieldId: string,
) => {
  const findFieldById = (field: CustomFieldValueLookupField) => field.id === customFieldId

  const value = customFields
    .find(section => section.fields.find(findFieldById))
    ?.fields.find(findFieldById)?.value

  return value ? JSON.parse(value) : undefined
}

interface FormatCustomFieldValueProps {
  kind: CustomFieldKind
  value: string
}
export const formatCustomFieldValue = ({ kind, value }: FormatCustomFieldValueProps) => {
  switch (kind) {
    case CustomFieldKind.money:
      return removeMoneyMask(value)
    case CustomFieldKind.number:
    case CustomFieldKind.boolean:
      return value
    default:
      return JSON.stringify(value)
  }
}
